var bookshelf = require("../index-extended");
require("./RecipientMeetingDoc");

module.exports = bookshelf.model("RecipientMeetingDoc", {
  entityName: "RecipientMeetingDoc",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "recipientMeetingDoc",
  recipientMeetingDocs() {
    return this.hasMany("RecipientMeetingDoc");
  },
});
